import React, { FC } from 'react'
import { breakpointDown, styled } from '@moonpig/launchpad-utils'
import { Box } from '@moonpig/launchpad-components'
import { DROPDOWN_ITEM_HEIGHT } from '../../../components/DropdownWithIcon/constants'
import { VariantsModule } from '../../Variants/VariantsModule'
import {
  ModuleContext,
  ModuleSimplifiedVariants,
  ModuleVariantsType,
} from '../../types'

type Props = {
  module: ModuleSimplifiedVariants
  context: ModuleContext
}

const StyledDropdownOverlay = styled(Box)`
  position: relative;
  height: ${({ theme }) =>
    `calc(${DROPDOWN_ITEM_HEIGHT} + ${theme.spacing[10]}px)`};

  ${breakpointDown('lg')} {
    height: ${({ theme }) =>
      `calc(${DROPDOWN_ITEM_HEIGHT} + ${theme.spacing[12]}px)`};
  }
  ${breakpointDown('md')} {
    height: ${({ theme }) =>
      `calc(${DROPDOWN_ITEM_HEIGHT} + ${theme.spacing[10]}px)`};
  }
`

const StyledDropdownOverlayContent = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
`

export const SimplifiedModuleVariants: FC<Props> = ({ module, context }) => {
  const variantsModule = (
    <VariantsModule
      module={{ ...module, __typename: 'ModuleVariants' }}
      context={context}
    />
  )

  if (module.type !== ModuleVariantsType.DROPDOWN) {
    return variantsModule
  }

  return (
    <StyledDropdownOverlay>
      <StyledDropdownOverlayContent>
        {variantsModule}
      </StyledDropdownOverlayContent>
    </StyledDropdownOverlay>
  )
}
